import { Component, OnInit,NgZone } from '@angular/core';
import { RegisterService } from '../register/register.service';
import { ProfileService } from './profile.service';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { Toast } from '../globals';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
  ListAllCity: any;
  model: any = {};

  constructor(private profile_serv:ProfileService, private register_serv: RegisterService, private router: Router, private alertController: AlertController, public zone: NgZone, private toastController: ToastController) {
    this.ShowCity();

    this.model.AppUserID=localStorage.getItem('Session_AppUserID');
    this.model.FirstName=localStorage.getItem('Session_Name');
    this.model.LastName=localStorage.getItem('Session_LastName');
    this.model.EmailAddress=localStorage.getItem('Session_EmailAddress');
    this.model.Password=localStorage.getItem('Session_Password');
    this.model.Phone=localStorage.getItem('Session_Phone');
    this.model.BrithDate=localStorage.getItem('Session_BrithDate');
    this.model.Sex=localStorage.getItem('Session_Sex');
    this.model.FK_CityID=localStorage.getItem('Session_FK_CityID');


  }

  ngOnInit() {
  }

  async presentToast(color, msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 1500,
      color: color,
      position: 'top'
    });

    await toast.present();
  }

  ShowCity() {
    this.register_serv.ShowCity().subscribe(
      res => {
        this.zone.run(() => {
          this.ListAllCity = res;
        });
      }, err => {
        console.log(err);
      });
  }

  UpdateProfile() {
    if (this.model.Sex == 'true') {
      this.model.Sex = true;
    } else {
      this.model.Sex = false;
    }
    this.model.FK_CityID = Number(this.model.FK_CityID);
    console.log(this.model);

    this.profile_serv.UpdateProfile(this.model).subscribe(
      res => {
        console.log("res", res)
        if (res == true) {

          this.presentToast('success', 'Update Successfully');
          this.model = {};
          this.router.navigate(["/home"]);

        } else if (res == false) {
          this.presentToast('warning', 'Email was Exist!');
        } else {
          this.presentToast('danger', 'Error Saving Data');
        }

      }, err => {
        console.log(err);
      });

  }


}
